import { v4 as uuidv4 } from 'uuid';

export const generateId = (n = 1) => {
    // if just need 1 id just return id as string
    if (n <= 1) return uuidv4();

    // return with array of string
    const idArray = [];
    for (let i = 0; i < n; i += 1) {
        idArray.push(uuidv4());
    }

    return idArray as string[];
};

export default { generateId };
